/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCampaignShowResponse } from '../../models/discount-campaign-show-response';

export interface GetDiscountShow$Params {
  id: string;
}

export function getDiscountShow(http: HttpClient, rootUrl: string, params: GetDiscountShow$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCampaignShowResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscountShow.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCampaignShowResponse>;
    })
  );
}

getDiscountShow.PATH = '/v1/discount/{id}';
